import React, { createContext, useState, useEffect, useCallback } from "react";

import {
  getSessionStorage,
  setSessionStorage,
} from "../pages/utils/sessionStorageUtils";
import {
  getAllStatuses,
  getAreas,
  getBairros,
  getGroups,
  getTarget,
  getEvaluations
} from "../components/Search/apiCalls";
import moment from "moment";

export const MapContext = createContext();

const dateInCache = getSessionStorage("mp_rangeOccurrences", {
  startDate: new Date(2021, 0, 1),
  endDate: new Date(),
});

const rangeOcurrencesInitialDate = {
  startDate: moment(dateInCache.startDate).toDate(),
  endDate: moment(dateInCache.endDate).toDate(),
};

const MapProvider = ({ children }) => {

  const [neighborhood, setNeighborhood] = useState(
    getSessionStorage("mp_neighborhood", { name: "Todos" })
  );
  const [area, setArea] = useState(getSessionStorage("mp_area", "Todos"));
  const [group, setGroup] = useState(getSessionStorage("mp_group", "Todos"));

  const [stateOccurrence, setStateOccurrence] = useState(
    getSessionStorage("mp_stateOccurrence", "Todos")
  );
  const [status, setStatus] = useState(getSessionStorage("mp_status", "Todos"));
  const [stepStatus, setStepStatus] = useState(
    getSessionStorage("mp_stepStatus", "Todos")
  );

  const [late, setLate] = useState(getSessionStorage("mp_late", "Todos"));
  const [rangeOccurrences, setRangeOccurrences] = useState(
    rangeOcurrencesInitialDate
  );
  const [complaintTarget, setComplaintTarget] = useState(
    getSessionStorage("mp_complaintTarget", "Todos")
  );

  const [evaluation, setEvaluation] = useState(
    getSessionStorage("mp_evaluation", "Todos")
  );

  const [complaintTargetList, setComplaintTargetList] = useState([]);
  const [areasList, setAreasList] = useState([]);
  const [groupsList, setGroupsList] = useState([]);
  const [neighborhoodsList, setNeighborhoodsList] = useState([]);
  const [statusesList, setStatusesList] = useState([]);

  const [evaluationsList, setEvaluationsList] = useState([]);


  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(true);
  const [mapPosition, setMapPosition] = useState([-6.5319859, -49.8526823]);
  const [mapZoom, setMapZoom] = useState(14);

  useEffect(() => {
    setSessionStorage("mp_neighborhood", neighborhood);
  }, [neighborhood]);

  useEffect(() => {
    setSessionStorage("mp_area", area);
  }, [area]);

  useEffect(() => {
    setSessionStorage("mp_group", group);
  }, [group]);

  useEffect(() => {
    setSessionStorage("mp_occurrenceStatus", stateOccurrence);
  }, [stateOccurrence]);

  useEffect(() => {
    setSessionStorage("mp_status", status);
  }, [status]);

  useEffect(() => {
    setSessionStorage("mp_stepStatus", stepStatus);
  }, [stepStatus]);

  useEffect(() => {
    setSessionStorage("mp_late", late);
  }, [late]);

  useEffect(() => {
    setSessionStorage("mp_rangeOccurrences", rangeOccurrences);
  }, [rangeOccurrences]);

  useEffect(() => {
    setSessionStorage("mp_complaintTarget", complaintTarget);
  }, [complaintTarget]);

  useEffect(() => {
    setSessionStorage("mp_stateOccurrence", stateOccurrence);
  }, [stateOccurrence]);

  useEffect(() => {
    setSessionStorage("mp_evaluation", evaluation);
  }, [evaluation]);

  const fetchData = useCallback(async () => {
    getAllStatuses().then((statuses) => {
      setStatusesList(statuses);
    });

    getGroups().then((groups) => {
      setGroupsList(groups);
    });

    getTarget().then((targets) => {
      const names = targets.map((target) => target.target);
      setComplaintTargetList(names);
    });

    getBairros().then((bairros) => {
      setNeighborhoodsList(bairros);
    });

    getAreas().then((areas) => {
      setAreasList(areas);
    });

    getEvaluations().then((evaluations) => {
      setEvaluationsList(evaluations);
    });

  }, []);

  useEffect(() => {
    fetchData().then(() => setLoading(false));
  }, [fetchData]);

  const value = {
    fetchData,
    neighborhood,
    setNeighborhood,
    area,
    setArea,
    group,
    setGroup,
    stateOccurrence,
    setStateOccurrence,
    status,
    setStatus,
    stepStatus,
    setStepStatus,
    late,
    setLate,
    rangeOccurrences,
    setRangeOccurrences,
    complaintTarget,
    setComplaintTarget,
    complaintTargetList,
    setComplaintTargetList,
    areasList,
    setAreasList,
    groupsList,
    setGroupsList,
    neighborhoodsList,
    setNeighborhoodsList,
    statusesList,
    setStatusesList,
    complaints,
    setComplaints,
    loading,
    setLoading,
    selectedItem,
    setSelectedItem,
    mapPosition,
    setMapPosition,
    mapZoom,
    setMapZoom,
    evaluation, setEvaluation,
    evaluationsList, setEvaluationsList
  };

  return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
};

export default MapProvider;
